type color = "brown" | "green";
interface Props {
    width: number;
    height: number;
    color: color;
    style?: React.CSSProperties;
}

const HLogo = ({ width, height, color, style }: Props) => {
    const LogoColor = color == "brown" ? "#462D2D" : "#608444";
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={String(width)}
            height={String(height)}
            viewBox="0 0 43 88"
            fill="none"
            style={style}
        >
            <g clipPath="url(#clip0_29_99)">
                <path
                    d="M40.4727 88C39.0713 88 37.9454 86.8654 37.9454 85.4799V67.5527L27.8123 57.4484L17.6791 67.5527V85.4799C17.6791 86.8773 16.5412 88 15.1518 88C13.7624 88 12.6245 86.8654 12.6245 85.4799V6.89142C12.6245 5.49403 13.7624 4.37134 15.1518 4.37134C16.5412 4.37134 17.6791 5.50597 17.6791 6.89142V60.4224L25.7641 52.3605C26.0755 51.9425 26.5187 51.6319 27.0097 51.4647C27.2493 51.3811 27.5128 51.3453 27.7883 51.3453H27.8003C28.1117 51.3453 28.4111 51.405 28.6866 51.5125C29.1058 51.6678 29.4772 51.9305 29.7526 52.2649L42.2574 64.734C42.7365 65.2117 43 65.8447 43 66.5136V85.4799C43 86.8654 41.8621 88 40.4727 88Z"
                    fill={LogoColor}
                />
                <path
                    d="M14.5771 44.7524C7.64198 44.7524 0.3236 38.9359 0.0121789 29.0706C-0.347153 17.8436 12.2534 1.64821 12.7924 0.967427C13.2715 0.358306 14.0022 0 14.7807 0H15.176C15.9545 0 16.6852 0.358306 17.1643 0.967427C17.7033 1.64821 30.3038 17.8556 29.9445 29.0706C29.6331 38.9359 22.3147 44.7405 15.3317 44.7405C15.2718 44.7405 15.2119 44.7405 15.152 44.7405H14.7807C14.7088 44.7524 14.6489 44.7524 14.5771 44.7524ZM15.176 39.7003C15.2239 39.7003 15.2718 39.7003 15.3317 39.7003C19.2005 39.7003 24.6623 36.392 24.9019 28.9153C25.1175 22.2747 18.901 12.0391 14.9843 6.49729C11.0676 12.0271 4.86315 22.2747 5.06678 28.9153C5.30633 36.4636 10.876 39.7839 14.7448 39.7003H15.176Z"
                    fill={LogoColor}
                />
                <path
                    d="M15.1399 34.1347C14.4931 34.1347 13.8463 33.8839 13.3552 33.3942L3.67718 23.7438C2.69501 22.7644 2.69501 21.164 3.67718 20.1727C4.65935 19.1933 6.26437 19.1933 7.25852 20.1727L15.1518 28.0435L23.9195 19.3008C24.9017 18.3214 26.5067 18.3214 27.5009 19.3008C28.483 20.2802 28.483 21.8806 27.5009 22.8719L16.9485 33.3942C16.4334 33.8839 15.7867 34.1347 15.1399 34.1347Z"
                    fill={LogoColor}
                />
            </g>
            <defs>
                <clipPath id="clip0_29_99">
                    <rect width={String(width)} height={String(height)} fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
export default HLogo;
